<template>
  <div>
    <form class="text-right">
      <v-btn class="pa-2 mt-1 text-right" color="#fff" style="color:#a9a9a9;" elevation="0" @click="toggleDialog()">
        <span class="mdi mdi-lock"></span>
        비밀번호 찾기
      </v-btn>

      <v-dialog v-model="showResetModal" @input="showResetModal = $event" max-width="600px">
        <v-card class="pa-3">
          <v-card-title>
            <span style="font-weight: bold; font-size: 24px;">비밀번호 찾기</span>
          </v-card-title>
          <Alert v-if="showAlert" :message="message" :message-type="messageType"></Alert>
          <v-card-text>
            <p>이메일을 입력 해 주세요.</p>
            <v-row>

              <v-col cols="4">
                <label>Email</label>
              </v-col>
              <v-col cols="8">
                <v-text-field v-model="changeEmail" outlined @keydown.enter="sendResetRequest"
                  color="black" :rules="emailRules"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn align-center depressed dark class="mb-2" :disabled="disableBtn"
              @click.prevent="sendResetRequest">비밀번호 찾기
            </v-btn> -->

            <TextButton buttonText="비밀번호 찾기" class="mr-2" :disabled="changeEmail === ''" @click="sendResetRequest" />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </form>
  </div>
</template>

<script>
import TextButton from '@/components/ui/button/TextButton2.vue';
import UserApi from '@/api/user/UserApi';
import Alert from '@/components/app/AppAlert.vue';

export default {
  data() {
    return {
      showResetModal: false,
      changeEmail: '',
      message: '',
      messageType: '',
      showAlert: false,
      emailRules: [
                v => !v || /.+@.+\..+/.test(v) || '이메일 주소를 정확히 입력해주세요.',
                // 이메일 형태 미기입시 뜨는 오류 힌트
            ],
    };
  },
  components: {
    TextButton,
    Alert
  },
  computed: {
    disableBtn() {
      return !this.changeEmail;
    }
  },
  methods: {
    async sendResetRequest() {
      try {
        const data = {
          email: this.changeEmail
        }
        const response = await UserApi.sendEmailApi(data);
        if (response.status === 1) {
          this.message = '비밀번호 재설정 메일이 전송되었습니다.';
          this.messageType = 'success';
          this.showAlert = true;
        } else {
          this.message = '오류가 발생했습니다.';
          this.messageType = 'error';
          this.showAlert = true;
        }
        setTimeout(() => {
          this.showResetModal = false;
        }, 10000);
      } catch (error) {
        this.message = '오류가 발생했습니다.';
        this.messageType = 'error';
        this.showAlert = true;
        setTimeout(() => {
          this.showAlert = false;
        }, 10000);
      }
    },
    toggleDialog() {
      this.showResetModal = !this.showResetModal;
      this.changeEmail = '';
      this.message = '';
      this.messageType = '';
      this.showAlert = false;
    },
  }

}
</script>

<style></style>